import {Observable} from 'rxjs';
import {Quality} from './qualities';

export interface Playable {
  source: string;
  isPlaying: boolean;
  playingState$: Observable<PlayingState>;
  loading$: Observable<number>;
  stats$: Observable<any>;

  attachMedia(video: HTMLVideoElement);

  loadSource(src: string);

  destroy();

  play();

  stop();

  setVolume(value: number);
}

export interface Seekable extends Playable {
  currentTime$: Observable<number>;
  totalTime$: Observable<number>;
  isSeekable: boolean;

  seek(position: number);
}

export interface SeekableLive extends Seekable {
  isLive: boolean;

  seekToLive();
}

export interface MultiBitrate extends Playable {
  qualities$: Observable<Quality[]>;
  currentQuality$: Observable<Quality>;

  switchToQuality(quality: Quality);
}

export enum PlayingState {
  PLAYING = '[STATE] playing',
  STARTED = '[STATE] started',
  PAUSED = '[STATE] paused',
  STOPPED = '[STATE] stopped',
}

export enum ContentType {
  MP4 = 'mp4',
  HLS = 'hls',
  VOD = 'vod',
}

export type AnyPlayable = Playable | Seekable | SeekableLive | MultiBitrate;
